import Repository from './Repository';

const resource = "/auth/profiles";
export default {
    get(id) {
        return Repository.get(`${resource}/${id}/`);
    },
    update(id, data) {
        return Repository.put(`${resource}/${id}/`, data);
    },
    upload(id, data) {
        return Repository.patch(`${resource}/${id}/`, data);
    },
}